// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { AckOutcome } from "./ack-outcome";
import { AckVerified } from "./ack-verified";
import { SequenceProgress, SequenceProgressT, verifySequenceProgress } from "./sequence-progress";
import { Uuid, UuidT, verifyUuid } from "./uuid";
import { ValuedMessage, ValuedMessageT, verifyValuedMessage } from "../ln2/valued-message";

export class FrontEndMessage implements flatbuffers.IUnpackableObject<FrontEndMessageT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): FrontEndMessage {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsFrontEndMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: FrontEndMessage,
  ): FrontEndMessage {
    return (obj || new FrontEndMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsFrontEndMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: FrontEndMessage,
  ): FrontEndMessage {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new FrontEndMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  bankId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  liftId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  timestamp(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readInt64(this.bb_pos + offset) : 0n;
  }

  msg(obj?: ValuedMessage): ValuedMessage | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset
      ? (obj || new ValuedMessage()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * True when the server synthesised this message rather than translating it
   * from something a vendor reported.
   *
   * VTS emits a derived message when one value supersedes another in a
   * mutually exclusive set: the displaced value needs an explicit
   * `active=false` because nothing else will report that it ended. That is
   * correct, but it is inference, and until now it was indistinguishable on
   * the wire from a reading. A door state that went false because a vendor's
   * pin went low and one that went false because VTS decided a peer had
   * superseded it arrived identically, so a wrong inference could only be
   * found by reconstructing the decision from a DEBUG trace.
   *
   * Consumers should read `false` as `a vendor reported this`. Appended at
   * the end of the table and defaulted to `false`, so existing writers keep
   * producing readable buffers and existing readers ignore the field.
   */
  derived(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  /**
   * The acknowledgement verdict, when this message reports one.
   *
   * Appended at the end and defaulted, exactly as `derived` was, so existing
   * writers keep producing readable buffers and existing readers ignore these
   * fields.
   *
   * These exist because the verdict cannot be re-derived downstream. Deciding
   * whether a command was answered requires remembering what was SENT, and the
   * only component that does is the correlator in VTS: a reader watching the
   * telemetry stream sees a value change but cannot tell an answer from a
   * coincidence, and cannot tell which of two meanings an address carries when
   * the read and write maps disagree about it. Carrying the verdict is
   * therefore not a convenience — it is the only place the question can be
   * answered correctly.
   */
  ackOutcome(): AckOutcome {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : AckOutcome.None;
  }

  /**
   * Whether the reported value matched the commanded one. See [`AckVerified`].
   */
  ackVerified(): AckVerified {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : AckVerified.Unknown;
  }

  /**
   * How long the controller took, in milliseconds. Zero when not applicable.
   */
  ackElapsedMs(): number {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  /**
   * A sequence run's progress, present exactly when `ack_outcome` is
   * `SequenceProgress`. Appended at the end; existing readers ignore it. The
   * `must_understand` marking lives on that enum value rather than on this
   * field, so a reader built before it skips only progress messages instead of
   * refusing every message written with this schema.
   */
  sequence(obj?: SequenceProgress): SequenceProgress | null {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset
      ? (obj || new SequenceProgress()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * Set when VTS drew this message from another bank's state (a bank overlay,
   * `FrontEndConfig.BankOverlay`): the message is a copy, re-addressed to
   * `bank_id`/`lift_id`, of a `Control` message that bank reported.
   *
   * Like `derived`, this is provenance: the copy is not a reading of the
   * target, so a consumer must not let it keep the target's lifts alive,
   * notify on it, or store it as the target's history (VTS never stores a
   * copy in `QuestDB`). Not `must_understand`: a reader that predates it shows
   * the copy as the target's own state, which is what the overlay is for.
   * Appended at the end and absent by default.
   */
  overlaySourceBankId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  static startFrontEndMessage(builder: flatbuffers.Builder) {
    builder.startObject(10);
  }

  static addBankId(builder: flatbuffers.Builder, bankIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, bankIdOffset, 0);
  }

  static addLiftId(builder: flatbuffers.Builder, liftIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, liftIdOffset, 0);
  }

  static addTimestamp(builder: flatbuffers.Builder, timestamp: bigint) {
    builder.addFieldInt64(2, timestamp, 0n);
  }

  static addMsg(builder: flatbuffers.Builder, msgOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, msgOffset, 0);
  }

  static addDerived(builder: flatbuffers.Builder, derived: boolean) {
    builder.addFieldInt8(4, +derived, +false);
  }

  static addAckOutcome(builder: flatbuffers.Builder, ackOutcome: AckOutcome) {
    builder.addFieldInt8(5, ackOutcome, AckOutcome.None);
  }

  static addAckVerified(builder: flatbuffers.Builder, ackVerified: AckVerified) {
    builder.addFieldInt8(6, ackVerified, AckVerified.Unknown);
  }

  static addAckElapsedMs(builder: flatbuffers.Builder, ackElapsedMs: number) {
    builder.addFieldInt32(7, ackElapsedMs, 0);
  }

  static addSequence(builder: flatbuffers.Builder, sequenceOffset: flatbuffers.Offset) {
    builder.addFieldOffset(8, sequenceOffset, 0);
  }

  static addOverlaySourceBankId(
    builder: flatbuffers.Builder,
    overlaySourceBankIdOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(9, overlaySourceBankIdOffset, 0);
  }

  static endFrontEndMessage(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // bank_id
    builder.requiredField(offset, 6); // lift_id
    builder.requiredField(offset, 10); // msg
    return offset;
  }

  static finishFrontEndMessageBuffer(builder: flatbuffers.Builder, offset: flatbuffers.Offset) {
    builder.finish(offset);
  }

  static finishSizePrefixedFrontEndMessageBuffer(
    builder: flatbuffers.Builder,
    offset: flatbuffers.Offset,
  ) {
    builder.finish(offset, undefined, true);
  }

  unpack(): FrontEndMessageT {
    return new FrontEndMessageT(
      this.bankId() !== null ? this.bankId()!.unpack() : null,
      this.liftId() !== null ? this.liftId()!.unpack() : null,
      this.timestamp(),
      this.msg() !== null ? this.msg()!.unpack() : null,
      this.derived(),
      this.ackOutcome(),
      this.ackVerified(),
      this.ackElapsedMs(),
      this.sequence() !== null ? this.sequence()!.unpack() : null,
      this.overlaySourceBankId() !== null ? this.overlaySourceBankId()!.unpack() : null,
    );
  }

  unpackTo(_o: FrontEndMessageT): void {
    _o.bankId = this.bankId() !== null ? this.bankId()!.unpack() : null;
    _o.liftId = this.liftId() !== null ? this.liftId()!.unpack() : null;
    _o.timestamp = this.timestamp();
    _o.msg = this.msg() !== null ? this.msg()!.unpack() : null;
    _o.derived = this.derived();
    _o.ackOutcome = this.ackOutcome();
    _o.ackVerified = this.ackVerified();
    _o.ackElapsedMs = this.ackElapsedMs();
    _o.sequence = this.sequence() !== null ? this.sequence()!.unpack() : null;
    _o.overlaySourceBankId =
      this.overlaySourceBankId() !== null ? this.overlaySourceBankId()!.unpack() : null;
  }

  unpackFields(...fields: string[]): FrontEndMessageT {
    const t = new FrontEndMessageT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("bank_id")) {
      t.bankId = this.bankId() !== null ? this.bankId()!.unpack() : null;
    }
    if (fieldSet.has("lift_id")) {
      t.liftId = this.liftId() !== null ? this.liftId()!.unpack() : null;
    }
    if (fieldSet.has("timestamp")) {
      t.timestamp = this.timestamp();
    }
    if (fieldSet.has("msg")) {
      t.msg = this.msg() !== null ? this.msg()!.unpack() : null;
    }
    if (fieldSet.has("derived")) {
      t.derived = this.derived();
    }
    if (fieldSet.has("ack_outcome")) {
      t.ackOutcome = this.ackOutcome();
    }
    if (fieldSet.has("ack_verified")) {
      t.ackVerified = this.ackVerified();
    }
    if (fieldSet.has("ack_elapsed_ms")) {
      t.ackElapsedMs = this.ackElapsedMs();
    }
    if (fieldSet.has("sequence")) {
      t.sequence = this.sequence() !== null ? this.sequence()!.unpack() : null;
    }
    if (fieldSet.has("overlay_source_bank_id")) {
      t.overlaySourceBankId =
        this.overlaySourceBankId() !== null ? this.overlaySourceBankId()!.unpack() : null;
    }
    return t;
  }
}

export class FrontEndMessageT implements flatbuffers.IGeneratedObject {
  constructor(
    public bankId: UuidT | null = null,
    public liftId: UuidT | null = null,
    public timestamp: bigint = 0n,
    public msg: ValuedMessageT | null = null,
    public derived: boolean = false,
    public ackOutcome: AckOutcome = AckOutcome.None,
    public ackVerified: AckVerified = AckVerified.Unknown,
    public ackElapsedMs: number = 0,
    public sequence: SequenceProgressT | null = null,
    public overlaySourceBankId: UuidT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.bankId === null || this.bankId === undefined) {
      throw new Error('Required field "bank_id" is not set');
    }
    if (this.liftId === null || this.liftId === undefined) {
      throw new Error('Required field "lift_id" is not set');
    }
    if (this.msg === null || this.msg === undefined) {
      throw new Error('Required field "msg" is not set');
    }
    const bankId = this.bankId !== null ? this.bankId!.pack(builder) : 0;
    const liftId = this.liftId !== null ? this.liftId!.pack(builder) : 0;
    const msg = this.msg !== null ? this.msg!.pack(builder) : 0;
    const sequence = this.sequence !== null ? this.sequence!.pack(builder) : 0;
    const overlaySourceBankId =
      this.overlaySourceBankId !== null ? this.overlaySourceBankId!.pack(builder) : 0;

    FrontEndMessage.startFrontEndMessage(builder);
    FrontEndMessage.addBankId(builder, bankId);
    FrontEndMessage.addLiftId(builder, liftId);
    FrontEndMessage.addTimestamp(builder, this.timestamp);
    FrontEndMessage.addMsg(builder, msg);
    FrontEndMessage.addDerived(builder, this.derived);
    FrontEndMessage.addAckOutcome(builder, this.ackOutcome);
    FrontEndMessage.addAckVerified(builder, this.ackVerified);
    FrontEndMessage.addAckElapsedMs(builder, this.ackElapsedMs);
    FrontEndMessage.addSequence(builder, sequence);
    FrontEndMessage.addOverlaySourceBankId(builder, overlaySourceBankId);

    return FrontEndMessage.endFrontEndMessage(builder);
  }

  clone(): FrontEndMessageT {
    const obj = new FrontEndMessageT();
    obj.bankId = this.bankId !== null ? this.bankId!.clone() : null;
    obj.liftId = this.liftId !== null ? this.liftId!.clone() : null;
    obj.timestamp = this.timestamp;
    obj.msg = this.msg !== null ? this.msg!.clone() : null;
    obj.derived = this.derived;
    obj.ackOutcome = this.ackOutcome;
    obj.ackVerified = this.ackVerified;
    obj.ackElapsedMs = this.ackElapsedMs;
    obj.sequence = this.sequence !== null ? this.sequence!.clone() : null;
    obj.overlaySourceBankId =
      this.overlaySourceBankId !== null ? this.overlaySourceBankId!.clone() : null;
    return obj;
  }

  equals(other: FrontEndMessageT): boolean {
    if (this.bankId !== null && other.bankId !== null) {
      if (!this.bankId!.equals(other.bankId!)) return false;
    } else if (this.bankId !== other.bankId) return false;
    if (this.liftId !== null && other.liftId !== null) {
      if (!this.liftId!.equals(other.liftId!)) return false;
    } else if (this.liftId !== other.liftId) return false;
    if (this.timestamp !== other.timestamp) return false;
    if (this.msg !== null && other.msg !== null) {
      if (!this.msg!.equals(other.msg!)) return false;
    } else if (this.msg !== other.msg) return false;
    if (this.derived !== other.derived) return false;
    if (this.ackOutcome !== other.ackOutcome) return false;
    if (this.ackVerified !== other.ackVerified) return false;
    if (this.ackElapsedMs !== other.ackElapsedMs) return false;
    if (this.sequence !== null && other.sequence !== null) {
      if (!this.sequence!.equals(other.sequence!)) return false;
    } else if (this.sequence !== other.sequence) return false;
    if (this.overlaySourceBankId !== null && other.overlaySourceBankId !== null) {
      if (!this.overlaySourceBankId!.equals(other.overlaySourceBankId!)) return false;
    } else if (this.overlaySourceBankId !== other.overlaySourceBankId) return false;
    return true;
  }
}

export function verifyFrontEndMessage(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "bank_id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "lift_id");
    verifier.checkScalarField(tablePos, 8, 8);
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 10);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyValuedMessage(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 10, "msg");
    verifier.checkScalarField(tablePos, 12, 1);
    verifier.checkScalarField(tablePos, 14, 1);
    verifier.checkScalarField(tablePos, 16, 1);
    verifier.checkScalarField(tablePos, 18, 4);
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 20);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifySequenceProgress(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 22);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
  } finally {
    verifier.popDepth();
  }
}

export function verifyRootAsFrontEndMessage(
  buf: DataView,
  opts?: flatbuffers.VerifierOptions,
): void {
  const verifier = new flatbuffers.Verifier(buf, opts);
  const tablePos = verifier.readUint32(0);
  verifyFrontEndMessage(verifier, tablePos);
}
